export default function Step6(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.3401 20.2694C18.1047 24.0467 29.5617 29.6204 31.3772 30.5036C31.5377 30.5817 31.7172 30.5782 31.8781 30.5008L53.0553 20.3141M31.6234 53.3809V30.7812M10.2687 19.9659C18.0184 15.9864 29.5093 10.0856 31.3659 9.1322C31.5327 9.04658 31.7223 9.05025 31.8895 9.1351L52.3979 19.5481C53.0694 19.8891 53.4924 20.5783 53.4924 21.3314V43.1131C53.4924 43.3377 53.3637 43.5424 53.1613 43.6398L31.8781 53.8775C31.7172 53.9549 31.5297 53.9544 31.3692 53.8763L10.3288 43.6405C10.1276 43.5426 10 43.3393 10 43.1157C10 40.863 10 28.6713 10 20.406C10 20.2185 10.1019 20.0516 10.2687 19.9659Z"
                stroke="black"
                strokeWidth="3"
            />
            <path d="M41.5584 14.2598L21.1039 25.3637V35.2987" stroke="black" strokeWidth="3" strokeLinecap="round" />
        </svg>
    );
}
